import {
  initialState,
  Actions,
  State,
  DELETE_PREJUDICIAL,
  DELETE_PREJUDICIAL_SUCCESS,
  DELETE_PREJUDICIAL_ERROR,
  RESET_DELETE_PREJUDICIAL,
} from "../../types/prejudicial/delete";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_PREJUDICIAL:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_PREJUDICIAL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_PREJUDICIAL_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_PREJUDICIAL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
